import PubSub from "pubsub-js";
import { useEffect } from "react";
import GA from "./events";
import eventType from "../eventType";

const SubscribersGa = () => {
	const { subscribe } = PubSub;

	useEffect(() => {

		if (!process.env.LOCALHOST) {
			subscribe(eventType.OFFER_CONTENT, (_, payload) => {
				GA.mountSelectContentOffer(payload);
			});
			subscribe(eventType.OFFER_EDIT, (_, payload) => {
				GA.mountSelectEditContentOffer(payload);
			});
			subscribe(eventType.OFFER_CONTENT_MOBILE, (_, payload) => {
				GA.mountSelectContentMobileOffer(payload);
			});
		}
	}, [subscribe]);

	return null;
};

export default SubscribersGa;
